import {
  createNotificationArray,
  generateLevels,
  transformFields,
} from "./function";
import {
  ApplyDateRangeI,
  ApprovalModalOptionsI,
  BulkApprovalI,
  DateFilterI,
  DateIsActiveI,
  DateRangeI,
  FileViewerEditableI,
  FileViewerShowI,
  FilterIsActiveI,
  LevelsI,
  RolesI,
  RowStyleI,
  TableIsActiveI,
  TriggerIsActiveI,
} from "./interface";

export const fieldsJSON: any = {
  documentId: { type: "string" },
  created_At: { type: "string" },
  comments: { type: "string" },
};

export const authenticateType: any = [
  { label: "Credentials", value: "credential" },
  { label: "JWT Token", value: "jwt" },
];

export const dateFilter: DateFilterI[] = [
  { label: "Created At", value: "created_At" },
  { label: "Updated At", value: "updated_At" },
];

export const defaultSchemaJson = [
  {
    label: "Created At",
    value: "createdAt",
  },
  {
    label: "Document Id",
    value: "documentId",
  },
];

export const filterIsActive: FilterIsActiveI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const SearchFilterIsActive: FilterIsActiveI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const DateIsActive: DateIsActiveI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const ApplyDateRange: ApplyDateRangeI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const FileViewerShowMode: FileViewerShowI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const sortBy: any[] = [
  { label: "Ascending", value: 1 },
  { label: "Descending", value: -1 },
];

export const sortIsActive: FilterIsActiveI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const notificationtIsActive: FilterIsActiveI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const triggerApprovals: any[] = [
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
];

export const notificationsApprovals: any[] = [
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
];

export const notificationsType: any[] = [
  { label: "Email", value: "email" },
  { label: "SMS", value: "sms" },
  { label: "Notification", value: "notification" },
];

export const userPermission: any[] = [
  { label: "Download Document", value: "download" },
  { label: "Send Mail", value: "mail" },
];

export const triggerActions: any[] = [
  { label: "Url", value: "url" },
  { label: "Email", value: "email" },
];

export const FileViewerEditableMode: FileViewerEditableI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const bulkApprovals: BulkApprovalI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const rowStyle: RowStyleI[] = [
  { label: "Left", value: "text" },
  { label: "Center", value: "number" },
  { label: "Right", value: "amount" },
];

export const levels: LevelsI[] = [
  {
    label: "Level-1",
    value: "level-1",
  },
  {
    label: "level-2",
    value: "level-2",
  },
  {
    label: "level-3",
    value: "level-3",
  },
  {
    label: "level-4",
    value: "level-4",
  },
  {
    label: "level-5",
    value: "level-5",
  },
];

export const roles: RolesI[] = [
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Approver",
    value: "approver",
  },
  {
    label: "Uploader",
    value: "uploader",
  },
  {
    label: "Viewer",
    value: "viewer",
  },
];

export const isActiveUser: FilterIsActiveI[] = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const isActivetrigger: TriggerIsActiveI[] = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const dateRanges: DateRangeI[] = [
  {
    label: "Last three months",
    value: "0-3",
  },
  {
    label: "Last six months",
    value: "0-6",
  },
  {
    label: "Last nine months",
    value: "0-9",
  },
];

export const tableIsActive: TableIsActiveI[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const approvalModalOptions: ApprovalModalOptionsI[] = [
  { label: "Labels", value: "isFile" },
  { label: 'Fields', value: 'fields' },
  { label: "Table", value: "isTable" },
  { label: "Word", value: "isWord" },
  { label: "Lab Report", value: "isCurebay" },
  { label: "Schema", value: "schema" },
  { label: "PDF Approval", value: "pdfApproval" },
  { label: "MDM", value: "mdm" },
  { label: "Files Verifications", value: "files_verification" },
];

export const fieldsArray = transformFields(fieldsJSON);

export const workFlowInitialValues: any = {
  logo: "",
  poExtractionType: 'extraction',
  flowName: "",
  isLogoUrl: false,
  processType: "",
  processName: "",
  regions: "",
  selectedUserProfile: undefined,
  workFlowName: undefined,
  identifier: undefined,
  reset_to_level_1: false,
  levels: 3,
  documentType: "",
  canAdditionalDocument: generateLevels(3),
  showAdditionalForm: [],
  fieldsToDisable: generateLevels(3),
  forwardDocument: false,
  forwardDocumentLevel: [],
  approvals: [
    {
      username: "",
      role: roles[1],
      level: levels[0],
      password: "abc123",
      addNew: 1,
      designation: "",
      canUpload: isActiveUser[1],
      isActive: isActiveUser[0],
      selectMode: "select-async",
      userPermission: ["download", "mail"],
    },
  ],
  triggers: [
    {
      approval: triggerApprovals,
      level: generateLevels(3),
      isActive: isActivetrigger[0],
      action: triggerActions[0],
      method: undefined,
      authenticate: true,
      authType: authenticateType[0],
      userName: "",
      password: "",
      token: "",
    },
  ],
  // sortBy: [{
  //   key: "created_At",
  //   mode: sortBy[1],
  // }],
  differentiateFirstLevel: false,
  updateFirstUserNotification: false,
  notification: createNotificationArray(3),
  sortBy: [
    {
      key: defaultSchemaJson[0],
      mode: sortBy[1],
      isActive: false,
    },
  ],
  searchFilter: {
    key: defaultSchemaJson[0],
    isActive: false,
  },
  withdrawalApproval: [],
  withdrawalLevel: [],
  bulkApproveApproval: false,
  bulkRejectApproval: false,
  filters: [
    {
      placeholder: "Select...",
      label: "Filter 1",
      key: defaultSchemaJson[0],
      isActive: filterIsActive[0],
      isMultiSelect: filterIsActive[0],
      filters: [{ key: "", label: "", isActive: true }],
    },
  ],
  dateFilter: {
    filterKey: dateFilter[0],
    rangeActive: true,
    range: dateRanges[0],
    showFilter: true,
    rangePicker: true,
  },
  fileViewer: {
    show: true,
    editable: true,
    tableFile: false,
    approvalModalOption: approvalModalOptions[0],
    showValue: true,
    showApprHistory: true,
  },
  tab: [
    {
      isActive: false,
      url: "",
      label: "",
      icon: "",
    },
  ],
  onboarding: false,
  table: [
    {
      isActive: tableIsActive[0],
      dateActive: true,
      filterActive: true,
      searchActive: true,
      header: {
        label: "Table 1",
        isActive: tableIsActive[0],
      },
      isPaginate: {
        paginationLimit: "",
        isActive: tableIsActive[0],
      },
      action: {
        view: false,
        edit: false,
        delete: false,
        downloadPDF: false,
        downloadExcel: false,
      },
      columnNameUpperCase: true,
      columnName: [
        {
          key: "documentId",
          label: "Document Id",
          isActive: true,
          isFile: false,
          fieldType: "string",
          fileView: false,
          fileDownload: false,
          sortActive: false,
          tooltipActive: false,
          truncatedActive: false,
          labelCenter: false,
          labelNoWrap: false,
          rowNoWrap: false,
          rowType: rowStyle[0],
        },
      ],
      drawerTable: [
        {
          label: "",
          isActive: true,
          labelCenter: false,
          labelNoWrap: false,
          rowNoWrap: false,
          rowType: rowStyle[0],
        },
      ],
    },
  ],
};


export const poExtractionTypes = [
  { label: "Extraction", value: "extraction" },
  { label: "Validation", value: "validation" },
  { label: "Po", value: "po" },
  { label: "Miro", value: "miro" }
]